// extracted by mini-css-extract-plugin
export default {"ArchiveIconStyle":"PublishingChannelListFilters_ArchiveIconStyle__4EIAa"};